import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取vip信息列表 **/
    GET_MEMBER_VIP_LIST(data) {
        controller='EsVip';
        action='getVipList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 新增vip信息 **/
    ADD_VIP(data) {
        controller='EsVip';
        action='addVip';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** vip信息上下架 **/
    CHANGE_SHOW(data) {
        controller='EsVip';
        action='editVipIsShow';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** vip排序修改 **/
    CHANGE_SORT(data) {
        controller='EsVip';
        action='editVipSort';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** vip信息修改 **/
    DEL_VIP(data) {
        controller='EsVip';
        action='delVip';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取vip信息 **/
    GET_VIP_INFO(data) {
        controller='EsVip';
        action='getVipDetail';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 编辑vip信息 **/
    EDIT_VIP(data) {
        controller='EsVip';
        action='editVip';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });   
    },

    /** 获取vip信息详情 **/
    GET_VIP_DETAIL(data) {
        controller='EsVip';
        action='getVipInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取vip充值信息详情 **/
    GET_VIP_DETAIL_LIST(data) {
        controller='EsVip';
        action='getVipRenewList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取vip续费列表-按会员分 **/
    GET_VIP_DETAIL_LIST_FROM_MEMBER(data) {
        controller='EsVip';
        action='getVipMemberRechargeList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取会员vip续费记录 **/
    GET_VIP_RENEW_LIST(data) {
        controller='EsVip';
        action='getVipMemberRechargeDetailList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取会员可退订vip金额和时间 **/
    GET_VIP_RENEW_CANCEL(data) {
        controller='EsVip';
        action='getVipMemberRechargeMoney';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 修改会员vip退款金额和时间 **/
    EDIT_VIP_RENEW_CANCEL(data) {
        controller='EsVip';
        action='editVipMemberRechargeMoney';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

   
}